//@flow
export const dayWidth = 31

export const colorCode = {
  ill: '#10d67c',
  vac: '#16aaf1',
  extra: '#ea4e76',
  all: 'grey'
}

export const absenceTypes = [
  {type: 'vac',   label: 'Urlaub'},
  {type: 'ill',   label: 'Krank'},
  {type: 'extra', label: 'Sonstiges'},
  {type: 'all',   label: 'Alle'},
]



// WEBPACK FOOTER //
// ./src/constants/absence.js